import { EnvironmentInjector, reflectComponentType, Type } from '@angular/core';
import { createCustomElement } from '@angular/elements';

import { makeTellentSelector } from '@core/tellent-util';

export const defineCustomElements = (
  components: Array<Type<any>>,
  injector: EnvironmentInjector,
): string[] => {
  const selectors: string[] = [];

  components.forEach(def => {
    try {
      const { selector } = reflectComponentType(def)!;
      const localSelector = makeTellentSelector(selector);

      customElements.define(
        localSelector,
        createCustomElement(def, {
          injector,
        }),
      );

      selectors.push(localSelector);
    } catch (err) {
      console.error(`Unable to define custom component`, def);
    }
  });

  return selectors;
};
